import { Component, Output, EventEmitter, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { NavigationEnd, Router, RouterModule } from '@angular/router';

import { NgScrollbarModule } from 'ngx-scrollbar';
import { DarkModeDropdownComponent } from 'src/app/shared/components/dark-mode-dropdown/dark-mode-dropdown.component';
import { LanguageDropdownComponent } from 'src/app/shared/components/language-dropdown/language-dropdown.component';
import { ProfileDropdownComponent } from 'src/app/pages/profile/profile-dropdown/profile-dropdown.component';
@Component({
    selector: 'app-header',
    imports: [RouterModule, NgScrollbarModule, TablerIconsModule, MaterialModule, DarkModeDropdownComponent, LanguageDropdownComponent, ProfileDropdownComponent, TranslateModule],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {
  @Input() showToggle = true;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();
  navActive: string = '';

  constructor(private router: Router) { }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateNavItems();
      }
    });
    this.updateNavItems();
  }

  private updateNavItems() {
    this.navActive = this.router.url;
  }

  routeLink(item: any) {
    this.navActive = this.router.url;
    return item.route;
  }
}

